import axios, { AxiosStatic } from "axios";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";

import "sweetalert2/dist/sweetalert2.min.css";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import * as Sentry from "@sentry/vue";

import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import { getField } from "./multilanguage";

Vue.config.productionTip = false;

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
Vue.prototype.$axios = axios;

Vue.prototype.$mlGet = (key: string): string => {
  return getField(store, key);
};

if (localStorage.getItem("authenticationToken")) {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("authenticationToken");
}

declare module "vue/types/vue" {
  interface Vue {
    $axios: AxiosStatic;
    $mlGet: (key: string) => string;
  }
}

Vue.use(VueSweetalert2);

Sentry.init({
  Vue,
  dsn:
    "https://895d81a6a5c77a5ca8027b1fa519adf7@o1159662.ingest.us.sentry.io/4510687101190144",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    Sentry.replayIntegration({
      networkDetailAllowUrls: [window.location.origin],
      networkDetailDenyUrls: [/.*\/user\/.*/, /.*\/login\/.*/],
    }),
  ],
  // Tracing
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /.*\/portal-api\/.*/],
  // Session Replay
  replaysSessionSampleRate: 0.5, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  enableLogs: true,

  environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || "development",
});

const vue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

export default vue;
